// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mrl2","newExpiryDate":"styles_newExpiryDate__2RfZg","footer":"styles_footer__3m8QN"};